import { render, staticRenderFns } from "./preAlert.vue?vue&type=template&id=268b8108&scoped=true"
import script from "./preAlert.vue?vue&type=script&lang=js"
export * from "./preAlert.vue?vue&type=script&lang=js"
import style0 from "./preAlert.vue?vue&type=style&index=0&id=268b8108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b8108",
  null
  
)

export default component.exports